<template>
    <div>
      <!-- <div v-if="percent==100">Success</div>  -->
        <div class="progress cstm_percentage_circle" v-if="percent>10">
          <PercentageCircle :percent="percent" size="large" active-color="blue" complete-color="green" :animate="true" />

                <!-- Excel Pop Up -->
        </div>
       
        <!-- //1st step     -->
        <file-upload
        :module_id="module_id"
        v-if="step === 'firstStep'"
        @getFileInfo="getFileInfo"
        >
            
        </file-upload>
            

<div v-else-if="step === 'secondStep'">
    <!-- <div class="flex justify-between">
        <h3>Header</h3>
        <h3>Select Mapping Excel</h3>
    </div> -->
    <form data-vv-scope="excel">
      <!-- {{errors}} -->
    <div class="pb-2 flex justify-between staff_excel_holder mb-3"
    v-for="(eachHeading,index) in staffHeading" :key="index">
      <div class="relative w-full">
        <label class="animated_label" :class="[focusedIndex == index || eachHeading.staff_heading? 'focused' : '']">{{eachHeading.field_label}}</label>
        <!-- <select v-model="eachHeading.staff_heading" v-validate="'required'" :name="eachHeading.field_label"  @search:focus="openselect(index)"
         class="w-100"   >
          <option :selected="item===eachHeading.field_label" :value="item"  class="w-100"  v-for="(item,index) in excelHeader" :key="index" >
            {{item}}{{item===eachHeading.field_label}}
          </option>
        </select> -->
            <v-select
            v-validate="'required'"
            :name="eachHeading.field_label"
            @search:focus="openselect(index)"
            class="w-100"
           v-model="eachHeading.staff_heading"
            :options="excelHeader"
            :selectable="option => !getSelectedHeading.includes(option)"

            ></v-select>
            <span v-show="errors.has(`excel.${eachHeading.field_label}`)" class="text-danger">{{ errors.first(`excel.${eachHeading.field_label}`) }}</span>
      </div>
<!-- <pre>{{staffHeading}}</pre> -->

    </div>
    <!-- {{getSelectedHeading}} -->
    <vs-button @click.prevent="finalImportExcel()">Save</vs-button>
</form>
  
</div>

<div v-else>
  <div class="cstm_vuexy_table">
    <!-- {{model}}
    {{uploadLead}}
 -->    <table v-if="model=== 'lead'">
      <tr>
        <th>Id</th>
        <th>First Name</th>
        <th>Last Name</th>
      </tr>
      <tr v-for="(eachLead,index) in uploadLead" :key="index"
      >
        <td>{{eachLead.id}}</td>
        <td>{{eachLead.lead_first_name}}</td>
        <td>{{eachLead.lead_last_name}}</td>
      </tr>
    </table>
     <table v-else>
      <tr>
        <th>Id</th>
        <th>First Name</th>
        <th>Last Name</th>
      </tr>
      <tr v-for="(eachLead,index) in uploadLead" :key="index"
      >
        <td>{{eachLead.id}}</td>
        <td>{{eachLead.first_name}}</td>
        <td>{{eachLead.last_name}}</td>
      </tr>
    </table>
  </div>

  <div class="my-4">
   

    <vs-button class="mr-2 mb-2"
    @click="addNewParentChild()"
    >Add New parent/child</vs-button>
  <!--   <pre>{{leadsCombination}}</pre>
    {{parentChildSelected}} -->
    <div class="flex flex-wrap justify-between combination_holder" v-for="(eachCombination,index) in leadsCombination"
    :key="index"
    >
      <fieldset class="w-full flex flex-wrap">
        <legend>Combination {{ index + 1 }}</legend>    
          <v-select
            @search:focus="openselect(index)"
            class="w-full p-1"
            v-model="leadsCombination[index].parent" 
            placeholder="Select Parent Name"
            :options="uploadLead"
            :getOptionLabel="getOptionLabel"
            :reduce="(option) => option.id"
            :selectable="option => !parentChildSelected.includes(option.id)"


            ></v-select>
            <v-select
            @search:focus="openselect(index)"
            class="w-full p-1"
            v-model="leadsCombination[index].children"
            placeholder="Select Children Name/s"
            :options="uploadLead"
            :multiple="true"
            :getOptionLabel="getOptionLabel"
            :reduce="(option) => option.id"
            :selectable="option => !parentChildSelected.includes(option.id)"


            ></v-select> 
      </fieldset>
      <div class="close_combination" @click.prevent="removeParent(index)">
        <span>&times;</span>
      </div>
    </div>

    <vs-button @click.prevent="lastStep()">Submit</vs-button>
  

</div>
   <a 
    :href="errorFile"
    v-if="errorFile"
    download
    target="_blank"
    >Download error log</a>
                <!-- 2nd Step -->


    </div>
    </div>
</template>
<script>
import PercentageCircle from 'vue-css-percentage-circle'
import FileUpload from '@/components/common/Excel/FileUpload.vue'
import {ExcelHeaderApi, getStaffDbHeaderApi, ModuleheaderApi, importExcelApi, importedBatchUpload, leadMapApi} from '@/api/excelApi'
import vSelect from 'vue-select'
export default {
  components:{
    FileUpload,
    vSelect,
    PercentageCircle
  },
  props: {
    module_id:{},
    model:{}
  },
  data () {
    return {
      percent: 10,
      firstStep:true,
      step:'firstStep',
      staffHeading:[],
      excelHeader:[],
      batch_id:'ayIxLjxlbfbZX2Nu1626080426',
      currentFilePath:'',
      current_file_id:null,
      errorFile:'',
      focusedIndex: null,
      uploadLead:[],
      leadsCombination:[],
      parentId:[],
      childrenId:[]
    }
  },
  created () {
    this.getSTaffDbHeader()
    /* this.step = 'thirdStep'
    const columnsPayload = {
      batch_id : 'eLgxb2F1M6pmh5241626249168'
    }
    this.batchUpload(columnsPayload) */
  },
  watch:{
    leadsCombination:{
      deep:true,
      handler () {
        this.leadsCombination.forEach((ele, index) => {
          if (ele.parent === null && ele.children.length > 0) {
            this.leadsCombination.splice(index, 1)
          }
        })
      }
    }
  },
  computed:{
    getSelectedHeading () {
      return this.staffHeading.filter(ele => ele.staff_heading).map(ele => ele.staff_heading)
    },
    parentChildSelected () {
      const selectedId = []
      this.leadsCombination.forEach(ele => {
        if (ele.parent)selectedId.push(ele.parent)
        selectedId.push(...ele.children)
      })
      return selectedId
    }
   
  },
  methods:{
    getOptionLabel (item) {
      if (this.model === 'lead') {
        return `${item.lead_first_name} ${item.lead_last_name}`
      } else {
        return `${item.first_name} ${item.last_name}`

      }
    },
    async lastStep () {
      const checkingEmptyParent = this.leadsCombination.filter(ele => !ele.parent)
      if (checkingEmptyParent.length) {
        this.showSuccessMessage('Error', 'Parent must be selected', 'danger')
      } else {
        const payload = {
          [this.model] :this.leadsCombination,
          batch_id:this.batch_id

        }
        try {
          const customer_id = localStorage.getItem('customer_id')
          await leadMapApi(customer_id, payload, this.model)
          this.showSuccessMessage('Success', `${this.model} Imported Successfully`, 'success')
          this.$emit('uploadSuccess', true)


        } catch (error) {
          this.showSuccessMessage('Error', error.data.message, 'danger')
        }
      }
    },
    removeParent (index) {
      this.leadsCombination.splice(index, 1)
    },
    addNewParentChild () {
      this.leadsCombination.push({parent:null, children:[]})
    },
    openselect (i) {
      this.focusedIndex = i
    },
    async finalImportExcel () {
      try {
        const result = await this.$validator.validateAll('excel')
        if (!result) {
          this.$vs.notify({
            title: 'Warning',
            text: 'All fields are required',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 3000
          })
        } else {
          const mandatoryField = await this.staffHeading.filter(ele => ele.enabled_parent).map(ele => ele.field_name)
          const mapFilter = this.staffHeading.filter(ele => {
            return  ele.staff_heading
          }).map(ele => ele.field_name)
          let checkingMandatory = true
          mandatoryField.forEach(ele => {
            if (!mapFilter.includes(ele)) {
              checkingMandatory = false
            }
          })
          if (checkingMandatory) {
            const payload = {}

            this.staffHeading.filter(ele => {
              return  ele.staff_heading
            }).forEach(ele => {
            
              payload[ele.field_name] = ele.staff_heading
            })
            const columnspayload = {
              file_path:this.currentFilePath,
              id:this.current_file_id,
              columns:payload
            }
            this.finalImport(columnspayload)
          } else {
            this.showSuccessMessage('Error', `${mandatoryField} must map this value`, 'danger')
          }
        }
      } catch (e) {

      }

    },
    async finalImport (columnspayload) {

      try {
        this.percent = Math.floor(Math.random() * (parseInt(50) - parseInt(30) + 1)) + parseInt(30)
        // this.$vs.loading(
        //   {
        //     text:this.percent+'%'
        //   }
        // )
        
        const customer_id = localStorage.getItem('customer_id')
        const data = await importExcelApi(this.model, customer_id, columnspayload)
        this.batch_id = data.data.data.batch_id
     
      } catch (error) {
        //this.$vs.loading.close()
        this.percent = 0 
        this.showSuccessMessage('Error', error.data.message, 'danger')
        this.errorFile = error.data.data.error_file
      } finally {
           
        const columnsPayload = {
          batch_id : this.batch_id
        }
        this.batchUpload(columnsPayload)
        //this.showSuccessMessage('Success', 'Excel Imported Successfully', 'success')
        // this.$emit('uploadSuccess',true)
        this.percent = 100
        // this.$vs.loading.close()
        setTimeout(() => {
          this.percent = 0 
        }, 1000)

      }
    },
    async batchUpload (columnspayload) {

      try {
        const customer_id = localStorage.getItem('customer_id')
        const data = await importedBatchUpload(this.model, customer_id, columnspayload)
        this.uploadLead = data.data.data.testLeads
        this.step = 'thirdStep'
        this.showSuccessMessage('Success', 'Excel Imported Successfully', 'success')
        // this.$emit('uploadSuccess',true)
      } catch (error) {
        this.showSuccessMessage(error.data.message)
        this.errorFile = error.data.data.error_file
      }
    },

    
    getFileInfo (filesInfo) {
      if (filesInfo) {
        this.step = 'secondStep'
        this.current_file_id = filesInfo.id
        this.currentFilePath = filesInfo.file_path
        this.getHeader(filesInfo.file_path)
      }
    },
    async getHeader (file_path) {
      const fileObject = {
        file_path
      }
      const customer_id = localStorage.getItem('customer_id')
      const {data} = await ExcelHeaderApi(customer_id, fileObject)
      this.excelHeader = data.data.headings
      this.staffHeading.forEach(ele => {
        if (this.excelHeader.includes(ele.field_label)) {
          ele['staff_heading'] = ele.field_label
        }
      })
    },
    async getSTaffDbHeader () {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const {data} = await ModuleheaderApi(customer_id, this.model)
        this.staffHeading = data.data
        this.staffHeading = this.staffHeading.map(ele => {
          return {
            ...ele,
            staff_heading:''
          }

        })
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>